import { UsageStateTypes, UsageActionTypes } from "./Usage.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: UsageStateTypes = {
  fetchAll: resetApiCallState([]),
};

const UsageReducer = (
  state: UsageStateTypes = INITIAL_STATE,
  action: any
): UsageStateTypes => {
  switch (action.type) {
    case UsageActionTypes.FETCH_ALL_USAGE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case UsageActionTypes.FETCH_ALL_USAGE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case UsageActionTypes.FETCH_ALL_USAGE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case UsageActionTypes.FETCH_ALL_USAGE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default UsageReducer;
